import React from "react";
import PropTypes from "prop-types";
import { withSearch } from "@elastic/react-search-ui";

function ClearFilters({ filters, clearFilters, render }) {
  const count = filters?.length || 0;
  if (render) {
    return render({ count, onClick: () => clearFilters() });
  }
  return (
    <button type="button" onClick={() => clearFilters()}>
      Reset filters ({count})
    </button>
  );
}

ClearFilters.propTypes = {
  filters: PropTypes.any,
  clearFilters: PropTypes.any,
  render: PropTypes.func,
};

export default withSearch(({ filters, clearFilters }) => ({
  filters,
  clearFilters,
}))(ClearFilters);
